import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';

import React from 'react';
import classnames from 'classnames';

import { Text, TextType } from 'ui-components/components/text';
import { Tooltip } from 'ui-components/components/tooltip';

import style from './filter-item.module.less';

/**
 * FilterItem component that provides a consistent layout for filter items
 * with support for labels and tooltips
 * @param {object} props - Component props
 * @param {React.ReactNode} props.label - The label for the filter item
 * @param {React.ReactNode} props.inputComponent - The input component (SimpleDropdown, NumberInput, etc.)
 * @param {React.ReactNode} [props.tooltipText] - Optional tooltip text to display next to the label
 * @param {string} [props.ariaLabel] - Aria label for the filter item container
 * @param {string} [props.className] - Additional class name for the container
 * @param {string} [props.id] - ID for the label element
 * @returns {React.ReactElement} The rendered FilterItem component
 */
export const FilterItem = ({ label, inputComponent, tooltipText, ariaLabel, className, id }) => {
  return (
    <div aria-label={ariaLabel} className={classnames(style['filter-item'], className)} role='group'>
      <div className={style['label-row']}>
        <Text className={style.label} id={id} textType={TextType.Label} value={label} />
        {tooltipText ? (
          <Tooltip position='top' text={tooltipText}>
            <span className={style['tooltip-icon']}>
              <FontAwesomeIcon icon={faInfoCircle} />
            </span>
          </Tooltip>
        ) : null}
      </div>
      <div className={style.input}>{inputComponent}</div>
    </div>
  );
};
